function updateBacklightingLogic() {
    document.querySelectorAll('fieldset').forEach(fieldset => {
      let containsNoOrBacklighting = false;

      fieldset.querySelectorAll('label').forEach(label => {
        const labelText = label.textContent.trim().toLowerCase();
        const img = label.querySelector('img');

        if (labelText.includes('no lighting') || labelText.includes('backlighting')) {
          if (img) img.style.display = 'none';
          containsNoOrBacklighting = true;
        } else {
          if (img) img.style.display = 'inline-block';
        }
      });

      // Clean previous class
      fieldset.classList.remove('has-no-or-backlighting');

      if (containsNoOrBacklighting) {
        fieldset.classList.add('has-no-or-backlighting');
      }
    });
  }

  // Run once when DOM loads
  document.addEventListener('DOMContentLoaded', updateBacklightingLogic);

  // Optional: observe DOM for changes (useful for Shopify dynamic content)
  const observer = new MutationObserver(updateBacklightingLogic);
  observer.observe(document.body, { childList: true, subtree: true });




// SCRIPT--FOR--UPDATING--PRICE--ON--PRODUCT--DETAIL--PAGE
document.addEventListener("DOMContentLoaded", function() {
  function syncPrice() {
    const priceElement = document.querySelector(".price__regular .price-item--regular");
    const estimationPriceElement = document.querySelector(".estimation-time p");

    if (priceElement && estimationPriceElement) {
      let priceText = priceElement.innerText.trim();
      // Optional: remove "From" text if needed
      priceText = priceText.replace(/^From\s*/, '');

      if (estimationPriceElement.innerText.trim() !== priceText) {
        estimationPriceElement.innerText = priceText;
      }
    }
  }

  // Run syncPrice every 300 milliseconds
  setInterval(syncPrice, 300);
});





// SCRIPT--FOR--UPDATING--CART--FOR--CUSTOM--PRODUCT
document.addEventListener('DOMContentLoaded', function() {
    function updateCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartCountElement = document.querySelector('.cart-count-bubble');
            if (cartCountElement) {
                cartCountElement.textContent = data.item_count;
                
                // Show/hide the bubble based on the cart count
                if (data.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                } else {
                    cartCountElement.style.display = 'none';
                }
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }

    document.querySelectorAll('.add-to-cart').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Update cart count
                updateCartCount();

                // Show pop-up notification
                const notification = document.getElementById('cart-notification');
                notification.style.display = 'block';
                setTimeout(() => {
                    notification.style.display = 'none';
                }, 3000);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    document.querySelectorAll('.buy-now').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Redirect to checkout
                window.location.href = '/checkout';
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    // Update cart count on page load
    updateCartCount();
});



document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart__remove')) {
        event.preventDefault();

        let lineItemKey = event.target.getAttribute('data-cart-item-key'); 

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 })
        })
        .then(response => response.json())
        .then(cart => {
            location.reload(); // Refresh the cart after removal
        })
        .catch(error => console.error('Error removing item:', error));
    }
});




document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("cart-remove-button a.button").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            let parentItem = this.closest(".cart__items");
            parentItem.classList.remove("cart__items--disabled"); // Remove the disable class if present

            fetch(this.href, {
                method: "POST"
            })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                console.log("Item removed", data);
                location.reload();  // Refresh cart after removal
            })
            .catch(error => console.error("Error removing item:", error));
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
  // Handle Remove Button Click
  document.querySelectorAll("cart-remove-button a").forEach(function (removeButton) {
    removeButton.addEventListener("click", function (event) {
      event.preventDefault();
      fetch(this.href, { method: "GET" }) // Send GET request to remove item
        .then(() => location.reload()) // Reload page after item is removed
        .catch(error => console.error("Error removing item:", error));
    });
  });

  // Handle Quantity Change
  document.querySelectorAll(".cart-quantity").forEach(function (quantityInput) {
    quantityInput.addEventListener("change", function () {
      let form = this.closest("form");
      if (form) {
        let formData = new FormData(form);
        fetch(form.action, {
          method: "POST",
          body: formData,
        })
          .then(() => location.reload()) // Reload page after quantity update
          .catch(error => console.error("Error updating quantity:", error));
      }
    });
  });
});













// / Left-offside-container
jQuery(document).ready(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});

jQuery(window).resize(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});
$(document).ready(function () {
    function updatePadding() {
        var windowWidth = $(window).width();

        if (windowWidth > 768) {
            var offset = $(window).width() - ($('.container').offset().left + $('.container').outerWidth());
            $('.featured-heading').css('padding-right', offset);
        } else {
            $('.featured-heading').css('padding-right', ''); 
        }
    }

    updatePadding(); // Run on page load
    $(window).resize(updatePadding); // Run on window resize
});
function updatePadding() {
    var windowWidth = $(window).width();
    var leftOffsetEl = $('.left-offset');

    if (windowWidth > 768 && leftOffsetEl.length) {
        $('.gemstone-flex').each(function (index) {
            var offset = $(window).width() - (leftOffsetEl.offset().left + leftOffsetEl.outerWidth());

            if (index % 2 === 0) {
                $(this).find('.gemstone-content').css('padding-left', offset);
                $(this).find('.gemstone-content').css('padding-right', '');
            } else {
                $(this).find('.gemstone-content').css('padding-right', offset);
                $(this).find('.gemstone-content').css('padding-left', '');
            }
        });
    } else {
        $('.gemstone-flex .gemstone-content').css({ 'padding-left': '', 'padding-right': '' });
    }
}

$(document).ready(updatePadding);
$(window).resize(updatePadding);



// jQuery(window).on('resize load', function() {
//     if (jQuery(window).width() > 767) {
//         var offset = jQuery('.left-offset').offset().left;
        
//         jQuery('.color-analysis').each(function(index) {
//             if (index % 2 === 0) {
//                 // Odd (0-based index, so this is actually the first, third, etc.)
//                 jQuery(this).find('.auto-container').css({
//                     'padding-left': offset,
//                     'padding-right': ''
//                 });
//             } else {
//                 // Even (second, fourth, etc.)
//                 jQuery(this).find('.auto-container').css({
//                     'padding-right': offset,
//                     'padding-left': ''
//                 });
//             }
//         });
//     } else {
//         jQuery('.auto-container').css({
//             'padding-left': '',
//             'padding-right': ''
//         });
//     }
// });

jQuery(window).on('resize load', function() {
    console.log("here"); // Check if the event is triggered

    var windowWidth = jQuery(window).width();

    if (windowWidth > 767) {
        var offsetElement = jQuery('.left-offset');

        if (offsetElement.length) {
            var offset = offsetElement.offset().left;
            console.log("Offset value:", offset); // Log offset value for debugging

            jQuery('.color-analysis').each(function(index) {
                var container = jQuery(this).find('.auto-container');

                if (container.length) {
                    if (index % 2 === 0) {
                        container.css({
                            'padding-right': offset,
                            'padding-left': '',
                        });
                    } else {
                        container.css({
                            'padding-left': offset,
                            'padding-right': '',
                        });
                    }
                }
            });
        }
    } else {
        console.log("Window width is ≤ 767px - Resetting styles");
        jQuery('.auto-container').css({
            'padding-left': '',
            'padding-right': '',
        });
    }
});





// TESTIMONIAL--SLIDER
jQuery(document).ready(function(){
    if (jQuery(window).width() > 320) {
        var $element = jQuery('.crafting-flex');
        var offsetRight = jQuery(window).width() - ($element.offset().left + $element.outerWidth());
        jQuery('.testimonialSwiper').css('right', offsetRight);
    }
});
jQuery(window).resize(function(){
    if (jQuery(window).width() > 320) {
        var $element = jQuery('.crafting-flex');
        var offsetRight = jQuery(window).width() - ($element.offset().left + $element.outerWidth());
        jQuery('.testimonialSwiper').css('right', offsetRight);
    }
});


// ===pop-up-js
$(document).ready(function(){
    $(".modal-trigger").click(function(e){
        e.preventDefault(); 

        // Get content from clicked button
        var heading = $(this).siblings("h3").text();
        var text = $(this).attr("data-popup-content"); 
        var decodedText = JSON.parse(text); 
        var imgSrc = $(this).closest(".analysis-flex").find(".analysis-img img").attr("src");

        // Set modal content
        $("#modalHeading").text(heading);
        $("#modalText").html(decodedText); 
        $("#modalImage").attr("src", imgSrc);

        // Show modal
        $("#analysisModal").fadeIn();
    });

    // Close modal
    $(".close").click(function(){
        $("#analysisModal").fadeOut();
    });

    $(window).click(function(e) {
        if ($(e.target).is("#analysisModal")) {
            $("#analysisModal").fadeOut();
        }
    });
}); 

 

// =========chart====== //
document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".Key-chart-table thead th");
    const rows = document.querySelectorAll(".Key-chart-table tbody tr");

    rows.forEach(row => {
        const cells = row.querySelectorAll("td");
        cells.forEach((cell, index) => {
            if (headers[index]) {
                cell.setAttribute("data-label", headers[index].textContent.trim());
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.matchMedia("(max-width: 993px)").matches) {
        let maxHeight = 0;

        const industriesCards = document.querySelectorAll('.Key-chart-table tbody tr th, .Key-chart-table tbody tr td');
        
        // Find the maximum height of the cards
        industriesCards.forEach(card => {
            const currentHeight = card.offsetHeight;
            if (currentHeight > maxHeight) {
                maxHeight = currentHeight;
            }
        });

        // Set all cards to the maximum height
        industriesCards.forEach(card => {
            card.style.height = `${maxHeight}px`;
        });
    }
});
// ==============form======

document.addEventListener("DOMContentLoaded", function () {
  const fields = document.querySelectorAll(".form-group input, .form-group textarea");

  fields.forEach((field) => {
    field.addEventListener("focus", function () {
      this.classList.add("active");
    });

    field.addEventListener("blur", function () {
      if (!this.value.trim()) {
        this.classList.remove("active");
      }
    });
  });
});




// document.addEventListener("DOMContentLoaded", function () {
//     const accordions = document.querySelectorAll(".accordion");

//     accordions.forEach((accordion) => {
//         const panel = accordion.nextElementSibling;
//         const selectedVariantElement = accordion.querySelector(".selected-variant");
//         const variantInputs = panel.querySelectorAll(".variant-option input");

//         // Initially, no variant is selected
//         selectedVariantElement.textContent = "Select an option";

//         variantInputs.forEach(input => {
//             input.addEventListener("change", function () {
//                 let parent = this.parentElement;
//                 let variantTitle = parent.getAttribute("data-title");

//                 // Update the displayed selected variant
//                 selectedVariantElement.textContent = variantTitle;

//                 // Close the accordion
//                 panel.classList.remove("open");
//                 panel.style.maxHeight = null;
//                 accordion.classList.remove("active");
//             });
//         });

//         // Keep all accordions open by default
//         if (panel) {
//             panel.classList.add("open");
//             panel.style.maxHeight = panel.scrollHeight + "px";
//         }

//         // Toggle accordion manually when clicking the header
//         accordion.addEventListener("click", function () {
//             if (panel.classList.contains("open")) {
//                 panel.classList.remove("open");
//                 panel.style.maxHeight = null;
//                 accordion.classList.remove("active");
//             } else {
//                 panel.classList.add("open");
//                 panel.style.maxHeight = panel.scrollHeight + "px";
//                 accordion.classList.add("active");
//             }
//         });
//     });
// });








 document.addEventListener("DOMContentLoaded", function () {
    // Select Stone Type
    document.querySelectorAll(".stone-item").forEach(item => {
        item.addEventListener("click", function () {
            document.querySelectorAll(".stone-item").forEach(i => i.classList.remove("selected"));
            this.classList.add("selected");
            document.getElementById("selected-stone").value = this.dataset.value;
        });
    });

    // Select Backlighting Option
    document.querySelectorAll(".backlight-item").forEach(item => {
        item.addEventListener("click", function () {
            document.querySelectorAll(".backlight-item").forEach(i => i.classList.remove("selected"));
            this.classList.add("selected");
            document.getElementById("selected-backlight").value = this.dataset.value;
        });
    });

    // Select Installation Preference
    document.querySelectorAll(".install-item").forEach(item => {
        item.addEventListener("click", function () {
            document.querySelectorAll(".install-item").forEach(i => i.classList.remove("selected"));
            this.classList.add("selected");
            document.getElementById("selected-install").value = this.dataset.value;
        });
    });
});
 